export const baseUrl = process.env.REACT_APP_KEYCLOAKAPI_URL;

export const keycloakapiUrls = {
    groups: () => `${baseUrl}/groups/`,
    users: () => `${baseUrl}/users/`,
    roles: () => `${baseUrl}/roles/`,
    permissions: () => `${baseUrl}/permissions/`,
    customers: () => `${baseUrl}/customers/`
};
